import { axios } from "@repo/http";
const useApiClient = ()=>axios;
export { useApiClient };
